import {useRouter} from 'next/router'
import type {Locales} from 'src/common/constants'

type Categories =
  | 'Corporate Cards'
  | 'Invoice Management & AP'
  | 'Accounting'
  | 'Finance Innovation & Leadership'
  | 'Reimbursements'
  | 'Budgeting & Cash Flow'
  | 'Spend Management'
  | 'AI & Intelligence'

export const getBlogPostCategory = (category: Categories, locale: Locales) => {
  if (!category || !locale) {
    return ''
  }

  const localizedCategory = CATEGORY_MAP[locale][category] || category

  return localizedCategory
}

export const useGetBlogPostCategory = (category: Categories | undefined) => {
  const {locale} = useRouter()

  if (!category) {
    return null
  }

  const localizedCategory = CATEGORY_MAP[locale as Locales][category] || category

  return localizedCategory
}

export const CATEGORY_MAP: Record<Locales, Record<string, string>> = {
  'en-us': {
    'Corporate Cards': 'Corporate Cards',
    'Invoice Management & AP': 'Invoice Management & AP',
    Accounting: 'Accounting',
    'Finance Innovation & Leadership': 'Innovation & Leadership',
    Reimbursements: 'Reimbursements',
    'Budgeting & Cash Flow': 'Budgeting & Cash Flow',
    'Spend Management': 'Spend Management',
    'AI & Intelligence': 'AI & Intelligence',
  },
  'en-gb': {
    'Corporate Cards': 'Corporate Cards',
    'Invoice Management & AP': 'Invoice Management & AP',
    Accounting: 'Accounting',
    'Finance Innovation & Leadership': 'Innovation & Leadership',
    Reimbursements: 'Reimbursements',
    'Budgeting & Cash Flow': 'Budgeting & Cash Flow',
    'Spend Management': 'Spend Management',
    'AI & Intelligence': 'AI & Intelligence',
  },
  'en-nl': {
    'Corporate Cards': 'Corporate Cards',
    'Invoice Management & AP': 'Invoice Management & AP',
    Accounting: 'Accounting',
    'Finance Innovation & Leadership': 'Innovation & Leadership',
    Reimbursements: 'Reimbursements',
    'Budgeting & Cash Flow': 'Budgeting & Cash Flow',
    'Spend Management': 'Spend Management',
    'AI & Intelligence': 'AI & Intelligence',
  },
  'en-de': {
    'Corporate Cards': 'Corporate Cards',
    'Invoice Management & AP': 'Invoice Management & AP',
    Accounting: 'Accounting',
    'Finance Innovation & Leadership': 'Innovation & Leadership',
    Reimbursements: 'Reimbursements',
    'Budgeting & Cash Flow': 'Budgeting & Cash Flow',
    'Spend Management': 'Spend Management',
    'AI & Intelligence': 'AI & Intelligence',
  },
  'de-de': {
    'Corporate Cards': 'Firmenkarten',
    'Invoice Management & AP': 'Rechnungsmanagement & Kreditorenbuchhaltung',
    Accounting: 'Buchhaltung',
    'Finance Innovation & Leadership': 'Finanzinnovation & Führung',
    Reimbursements: 'Spesenabrechnungen',
    'Budgeting & Cash Flow': 'Budgetierung & Cashflow',
    'Spend Management': 'Ausgabenmanagement',
    'AI & Intelligence': 'KI & Intelligenz',
  },
  'de-at': {
    'Corporate Cards': 'Firmenkarten',
    'Invoice Management & AP': 'Rechnungsmanagement & Kreditorenbuchhaltung',
    Accounting: 'Buchhaltung',
    'Finance Innovation & Leadership': 'Finanzinnovation & Führung',
    Reimbursements: 'Spesenabrechnungen',
    'Budgeting & Cash Flow': 'Budgetierung & Cashflow',
    'Spend Management': 'Ausgabenmanagement',
    'AI & Intelligence': 'KI & Intelligenz',
  },
  'nl-nl': {
    'Corporate Cards': 'Zakelijke kaarten',
    'Invoice Management & AP': 'Factuurbeheer & crediteurenadministratie',
    Accounting: 'Boekhouding',
    'Finance Innovation & Leadership': 'Innovatie & leiderschap',
    Reimbursements: 'Onkostenvergoedingen',
    'Budgeting & Cash Flow': 'Budgettering & cashflow',
    'Spend Management': 'Uitgavenbeheer',
    'AI & Intelligence': 'AI & intelligentie',
  },
}
